import {Permission, Role, Roles} from "../types";
import {convertKeysToCamelCase} from "@shared/utils";

export const rolesMockData: Roles = {
  "total": 17,
  "data": convertKeysToCamelCase([
    {
      "description": "Study Manager",
      "name": "Study Manager",
      "is_internal": false,
      "study_level": true,
      "site_level": false,
      "permissions": [
        {
          "name": "Study Detail",

          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "8b60a742-39c1-44a3-b0e1-bc0a5e728b70",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "Site Study Detail",

          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "c355d5b2-83ae-4001-b5ce-0a723ba9b3a0",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "Site Detail",

          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "2f4ebc56-7427-4f78-865b-b7a402e32e84",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "Study Submission",

          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "e7106664-55a2-4327-ae49-776e0ed51828",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "Site Submission",

          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "35d8775d-a0b4-410e-82ce-e00a2af19666",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "New Site Submission",

          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "f7bdb9b1-a927-412d-bf9a-c67a8ae73148",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "Study Correspondence",

          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "3950fa28-fa1f-4ab3-97c9-8f63fd5da1d2",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "Site Correspondence",

          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "384cf75f-d05c-482e-b15f-995f2561c7ef",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "Study Team",


          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "61031acf-f20b-402f-8cac-ce9cf6455b23",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        },
        {
          "name": "Site Team",


          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "a80428ee-fc16-4c5c-b44b-1db68a94e864",
          "role_id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
        }
      ],
      "id": "4f5ed88b-11e7-4837-9f3f-c62c1780a27a"
    },
    {
      "description": "Study Submitter",
      "name": "Study Submitter",
      "is_internal": false,
      "study_level": true,
      "site_level": false,
      "permissions": [
        {
          "name": "Study Detail",


          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "dc5fb6e5-4d42-4093-9754-17bf3255fadb",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "Site Study Detail",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "b160fa90-09ae-4d42-81c2-7e7e8aba9a39",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "Site Detail",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "6d863d51-44d5-484b-9eec-af51d3e17164",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "Study Submission",

          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "e17fcaf6-e9c5-4d44-8afd-dbdc2551f10c",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "Site Submission",

          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "a4581789-7026-4555-85ed-eb283f7213f7",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "New Site Submission",

          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "9a5ce8ce-5604-42c4-aaad-04fece92f31b",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "Study Correspondence",

          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "56c07aef-cbe1-4bca-ab97-76a239954bcf",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "Site Correspondence",

          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "a42b3fea-5ea9-49db-a01c-a91a4a426b7e",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "Study Team",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "5c0bc104-6e16-488e-b470-f6536c052c9c",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        },
        {
          "name": "Site Team",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "3aec83ed-8ade-4cd3-88d4-0453775b306c",
          "role_id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
        }
      ],
      "id": "f9eba837-5653-4f9f-b67a-5e839aec4511"
    },
    {
      "description": "Study Visibility",
      "name": "Study Visibility",
      "is_internal": false,
      "study_level": true,
      "site_level": false,
      "permissions": [
        {
          "name": "Study Detail",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "df26225a-093e-4942-9fbd-0d00bc971348",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "Site Study Detail",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "b137329d-c5a6-4f1e-83e7-e69f25203d7f",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "Site Detail",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "771b975a-6144-4000-b67b-e8959776a0a3",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "Study Submission",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "05a54457-b6cb-4cb3-abef-e69bbe856290",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "Site Submission",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "4f297394-dd9a-4074-9d30-7962480fd943",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "New Site Submission",

          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "983fe036-e176-47c6-aae4-800a59167fed",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "Study Correspondence",


          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "34e93201-cf43-456a-bd30-bd380c01ab5d",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "Site Correspondence",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "44fd2861-d2d0-48b7-ad48-918d0a7e6152",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "Study Team",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "84b95ff7-3f12-40cd-989d-5fe484bcc0ef",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        },
        {
          "name": "Site Team",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "49fae3cd-9441-46d7-9060-168a596884eb",
          "role_id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
        }
      ],
      "id": "9e09b79f-c574-4473-a3ea-d7daa3ed6bbc"
    },
    {
      "description": "Site Participant",
      "name": "Site Participant",
      "is_internal": false,
      "study_level": true,
      "site_level": false,
      "permissions": [
        {
          "name": "Study Detail",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "62efa16f-10ad-4333-8267-3cf1dd919251",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "Site Study Detail",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "69728cc5-5e21-4142-961a-cfbe032303b0",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "Site Detail",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "53a2c911-2069-411a-91f1-af06756b4a60",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "Study Submission",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "385ebf72-4e00-4b93-b8c8-d55ddf137468",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "Site Submission",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "f0129f91-10fd-415b-947b-7b7dffeeb21f",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "New Site Submission",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "fca9ef1d-b1aa-44be-9406-85ac568e9be2",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "Study Correspondence",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "851ee420-24db-42d7-b4f8-04d992a3701b",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "Site Correspondence",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": true,
          "can_create": false,
          "can_remove": true,
          "id": "3f383d7b-b559-4122-beb8-fc577d1d96de",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "Study Team",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "282c8502-8ed6-4903-9a62-a95e4602bae8",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        },
        {
          "name": "Site Team",
          "object_class": null,
          "object_id": null,
          "columns": null,
          "can_view": true,
          "can_edit": false,
          "can_create": false,
          "can_remove": false,
          "id": "bdcbacca-4901-499c-bc7d-a8a18e735009",
          "role_id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
        }
      ],
      "id": "f0d23ae5-85c1-48ab-8116-9bc20a96c6b1"
    },
  ]) as unknown as Role[]
};

export const permissionsMockData: Permission[] = convertKeysToCamelCase([
  {
    "name": "Study Detail",
    "description": "This relates to the study itself and the permissions surrounding viewing the study.",
    "level": "study",
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": false,
    "can_remove": false
  },
  {
    "name": "Site Study Detail",
    "description": "This relates to the study itself and the permissions surrounding viewing the study.",
    "level": "study",
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": false,
    "can_remove": false
  },
  {
    "name": "Site Detail",
    "description": "This relates to the site itself and the permissions surrounding viewing the site.",
    "level": "site",
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": false,
    "can_remove": false
  },
  {
    "name": "Study Submission",
    "description": "This relates to the study itself and the permissions surrounding editing the study and viewing the study.",
    "level": "study",
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": true,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Site Submission",
    "description": "This relates to the site itself and the permissions surrounding editing the site and viewing the site",
    "level": "site",
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": true,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "New Site Submission",
    "description": "This relates to the site itself and the permissions surrounding creating a new site",
    "level": "site",
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": true,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Study Correspondence",
    "description": "This relates to the permissions surrounding editing the study correspondence and viewing the study correspondence.",
    "level": "study",
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Site Correspondence",
    "description": "This relates to the permissions surrounding editing the site correspondence and viewing the site correspondence.",
    "level": "site",
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Study Team",
    "description": "This relates to the permissions surrounding editing the study team and viewing the study team.",
    "level": "study",
    "columns": [
      "StudyContact.team"
    ],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Site Team",
    "description": "This relates to the permissions surrounding editing the site team and viewing the site team.",
    "level": "site",
    "columns": [
      "StudyContact.team"
    ],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "People Admin",
    "description": "This relates to the permissions surrounding editing the people and viewing the people.",
    "level": "study",
    "columns": [
      "StudyContact.team"
    ],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Role Admin",
    "description": "This relates to the permissions surrounding editing the roles and viewing the roles.",
    "level": "study",
    "columns": [
      "StudyContact.team"
    ],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Notification Admin",
    "description": "This relates to the permissions surrounding editing the notifications and viewing the notifications.",
    "level": "study",
    "columns": [
      "StudyContact.team"
    ],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Questionnaire Admin",
    "description": "This relates to the permissions surrounding editing the questionnaires and viewing the questionnaires.",
    "level": "study",
    "columns": [
      "StudyContact.team"
    ],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Submission Super Admin",
    "description": "This relates to the permissions surrounding editing the submissions and viewing the submissions.",
    "level": "study",
    "columns": [
      "StudyContact.team"
    ],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Document Super Admin",
    "description": "This relates to the permissions surrounding editing the documents and viewing the documents.",
    "level": "study",
    "columns": [
      "StudyContact.team"
    ],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "User Permission",
    "description": "Base user permission for the system.",
    "level": null,
    "columns": [],
    "is_internal": false,
    "can_view": true,
    "can_create": false,
    "can_edit": true,
    "can_remove": false
  },
  {
    "name": "Admin User Permission",
    "description": "Base admin user permissions for the system.",
    "level": null,
    "columns": [],
    "is_internal": true,
    "can_view": true,
    "can_create": true,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "Business Admin Permission",
    "description": "Base business admin permissions for the system.",
    "level": null,
    "columns": [],
    "is_internal": true,
    "can_view": true,
    "can_create": true,
    "can_edit": true,
    "can_remove": true
  },
  {
    "name": "IT Admin Permission",
    "description": "Base IT admin permissions for the system.",
    "level": null,
    "columns": [],
    "is_internal": true,
    "can_view": true,
    "can_create": true,
    "can_edit": true,
    "can_remove": true
  }
]) as unknown as Permission[]

export const userRoleMockData = {
  "description": "Study Manager",
  "name": "Study Manager",
  "is_internal": false,
  "study_level": true,
  "site_level": false,
  "permissions": [{
    "name": "Site Submission",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": true,
    "can_create": false,
    "can_remove": true,
    "id": "bccee213-ab1e-4996-8edd-20fe335bfd0b",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "New Site Submission",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": true,
    "can_create": false,
    "can_remove": true,
    "id": "6f7bc0f9-fb7a-4d06-af64-fc6e4fbf9bcd",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "Study Correspondence",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": true,
    "can_create": false,
    "can_remove": true,
    "id": "073ae31d-206e-4d6d-aab5-f6305160f716",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "Site Correspondence",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": true,
    "can_create": false,
    "can_remove": true,
    "id": "d06d93f1-f2b1-4486-8f32-c44befb18dee",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "Study Team",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": true,
    "can_create": false,
    "can_remove": true,
    "id": "005cfd62-a994-43a6-ac4d-e2de9171f7aa",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "Study Detail",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": false,
    "can_create": false,
    "can_remove": false,
    "id": "1b187a76-45e5-4741-95e1-7265fc277a97",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "Site Study Detail",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": false,
    "can_create": false,
    "can_remove": false,
    "id": "59d54c55-0514-42c5-b4c2-c11433bc4061",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "Site Detail",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": false,
    "can_create": false,
    "can_remove": false,
    "id": "4062b2c4-33f3-49d9-8e5f-ef97b46b8ab9",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "Study Submission",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": true,
    "can_create": false,
    "can_remove": true,
    "id": "8a3f0f0e-27a9-455d-a20a-27f5803fa23d",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }, {
    "name": "Site Team",
    "object_class": null,
    "object_id": null,
    "columns": [],
    "can_view": true,
    "can_edit": true,
    "can_create": false,
    "can_remove": true,
    "id": "51db9ad0-df17-4e82-b386-71186465e2fa",
    "role_id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
  }],
  "id": "706339f5-dbb3-4447-bd40-9e0607bab77f"
} as unknown as Role;
